module.exports = __webpack_public_path__ + "static/media/1-5.79e348d8.mp3";